import { Random, Validation, expectNever } from "~/utils";
import { Game } from "./Game";
import { GameCommandByPlayer, getCommandArg } from "./GameApi";

export const getCommandValidation = (
  game: Game,
  command: GameCommandByPlayer
): Validation => {
  const validation = getCommandValidationInternal(game, command);
  return validation;
};

const getCommandValidationInternal = (
  game: Game,
  command: GameCommandByPlayer
): Validation => {
  const { playerId, methodName } = command;
  switch (methodName) {
    case "buyCard": {
      const arg = getCommandArg<typeof methodName>(command);
      return game.validateBuyCard(playerId, arg);
    }
    case "play": {
      const arg = getCommandArg<typeof methodName>(command);
      return game.validatePlay(playerId, arg.cardId, arg.actionSlotId);
    }
    case "playIntrigue": {
      const arg = getCommandArg<typeof methodName>(command);
      return game.validatePlayIntrigue(playerId, arg);
    }
    case "endBuyPhase": {
      return game.validateEndBuyPhase(playerId);
    }
    case "revealAll": {
      return game.validateRevealAll(playerId);
    }
    case "passIntrigue": {
      return game.validatePassIntrigue(playerId);
    }
    case "playGlobalEffect": {
      return game.validatePlayGlobalEffect(playerId);
    }
    case "answerChoice": {
      const arg = getCommandArg<typeof methodName>(command);
      return game.validateAnswerChoice(playerId, arg);
    }
    case "useTech": {
      const techId = getCommandArg<typeof methodName>(command);
      return game.validateUseTech(playerId, techId);
    }
    case "askUndo": {
      return;
    }
    case "answerUndo": {
      return;
    }
    default: {
      expectNever(methodName);
      throw new Error("never");
    }
  }
};
